var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dataEffect"},[_c('div',{staticClass:"dataEffect-menu"}),_vm._v(" "),_c('div',{staticClass:"dataEffect-content"},[_c('div',{staticClass:"layout-content"},[_vm._t("default")],2)]),_vm._v(" "),_c('input',{staticStyle:{"position":"fixed","bottom":"-99999px"},attrs:{"type":"text","id":"copyInput"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cd9891c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/layout.vue
// module id = null
// module chunks = 